import { useStoreProps as r } from "./RTNCFSKZ.js";
import { useUpdateEffect as s } from "./5GGHRIN3.js";
function i(e, o, t) {
  return s(o, [t.store]), r(e, t, "items", "setItems"), e;
}
export {
  i as useCollectionStoreProps
};
//# sourceMappingURL=AMMIPFT4.js.map
